import { createStore } from 'zustand/vanilla';

// src/auth/authStore.ts
var initialState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  isLoading: false,
  error: null
};
function createAuthStore() {
  return createStore()((set) => ({
    ...initialState,
    setUser: (user) => set({ user, isAuthenticated: true, isLoading: false, error: null }),
    setAccessToken: (token) => set({ accessToken: token }),
    setRefreshToken: (token) => set({ refreshToken: token }),
    setLoading: (loading) => set({ isLoading: loading }),
    setError: (error) => set({ error, isLoading: false }),
    logout: () => set({ ...initialState }),
    reset: () => set({ ...initialState })
  }));
}

export { createAuthStore };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map